import { render, staticRenderFns } from "./SetPasswordView.vue?vue&type=template&id=54be2ae8"
import script from "./SetPasswordView.vue?vue&type=script&lang=js"
export * from "./SetPasswordView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports